import React, { useEffect } from "react";
import "./Cloud.css";
import cloud from "../../../Images/cloudabout-removebg-preview.png";
import ScrollMagic from "scrollmagic";

const Cloudpage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const controller = new ScrollMagic.Controller();

    const triggerElement = document.getElementById("triggerPinned");

    if (window.innerWidth > 768 && triggerElement) {
      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: 0,
      })
        .setPin(triggerElement)
        .addTo(controller);
    }

    return () => controller.destroy();
  }, []);
  const cloudServices = [
    {
      title: "Cloud Strategy & Consulting",
      description:
        "Define the right cloud approach for your business (public, private, or hybrid).",
    },
    {
      title: "Cloud Migration",
      description:
        "Seamlessly move your applications, data, and infrastructure to the cloud with minimal downtime.",
    },
    {
      title: "Cloud Infrastructure Management",
      description: "Ensure performance, uptime, and security across AWS, Azure, or GCP.",
    },
    {
      title: "DevOps & Automation",
      description:
        "Enable continuous integration and deployment (CI/CD) to speed up delivery and reduce errors.",
    },
    {
      title: "Disaster Recovery & Backup Solutions",
      description: "Protect your data and ensure business continuity.",
    },
    {
      title: "Cost Optimization & Monitoring",
      description: "Gain control over your cloud spend with smart tracking and performance tuning.",
    },
  ];

  return (
    <div>
      <div className="cloud-banner-page" id="triggerPinned">
        <h1>Your Cloud. Your Way. Fully Powered. Always Secure.</h1>
      </div>
      <div className="white-section">
        <div className="about-content-page">
          <div className="left-content-about">
            <h1>Scalable. Secure. Future-Ready.</h1>
            <p>
              At Owision, we empower organizations to accelerate digital transformation with agile,
              scalable, and cost-efficient Cloud Services. Whether you're migrating legacy systems,
              building cloud-native applications, or optimizing multi-cloud environments, we provide
              end-to-end support tailored to your business goals.
            </p>
          </div>
          <div className="right-content-about">
            <img src={cloud} alt="cloud" />
          </div>
        </div>
        <div className="cloud-card-container">
          <h1>Our Cloud Offerings Include</h1>
          <div className="clould-card-services">
            {cloudServices.map((service, index) => (
              <div className="cloud-card" key={index}>
                <h2>{service.title}</h2>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cloudpage;
